import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_ORDER_FILES } from "../queries/GetOrderDetails";

const fetchGetOrderFilesBySO = async ({ queryKey }) => {
    const [, { token, item, setToast }] = queryKey;

    if (!token) throw new Error("Token not available");

    try {
        const response = await axios.get(
            `/getOrdersFileBySO/?orderDetailId=${encodeURIComponent(item.orderDetailId)}`,
            {
                headers: {
                    Authorization: token,
                },
            }
        );

        return response.data;
    } catch (error) {
        setToast({ showToast: true ,message:  error.message, type: 'error' });
    }
};

export const useGetOrderFiles = (params) => {
    return useQuery({
        queryKey: [GET_ORDER_FILES, params],
        queryFn: fetchGetOrderFilesBySO,
        enabled: !!params.token,
        retry: false,
    });
};